import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import operationLog from './components/operation-log.vue';
import loginLog from './components/login-log.vue';
import deviceManagement from '@blade-sxp/account/pages/log/components/device-management.vue';
import FullScreen from '@blade/common/components/full-screen.vue';
import moment from 'moment';
import { exportLog, TASK_TYPE } from '@blade/common/api/export-target';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
let default_1 = class extends Vue {
    srcMsg = require('@blade/common/assets/svgs/enlarge.svg');
    srcMsg2 = require('@blade/common/assets/svgs/narrow.svg');
    permissionlevel = permissionlevel;
    keyword = '';
    endTime = '';
    startTime = '';
    logData = '';
    activeName = 'first';
    onFullScreenFlag = false;
    fullSkDialogVisible = false;
    handleSearch() {
        if (this.activeName === 'first') {
            // 登录日志
            this.$refs.loginLog.getLogLoginList(true);
        }
        else if (this.activeName === 'second') {
            // 操作日志
            this.$refs.operationLog.getLogOpList(true);
        }
        else {
            this.$refs.deviceManagement.getList(true);
        }
    }
    onFullScreen() {
        this.onFullScreenFlag = !this.onFullScreenFlag;
        this.$refs.fullscreen.toggle();
    }
    pickerOptions() {
        if (this.logData && this.logData.length) {
            this.startTime = this.logData[0] ? moment(this.logData[0]).format('YYYY-MM-DD HH:mm:ss') : '';
            this.endTime = this.logData[1] ? moment(this.logData[1]).format('YYYY-MM-DD HH:mm:ss') : '';
        }
        else {
            this.endTime = '';
            this.startTime = '';
        }
    }
    handleExport() {
        const isLoginLog = this.activeName === 'first';
        const logInfo = isLoginLog ? this.$refs.loginLog : this.activeName === 'second' ? this.$refs.operationLog : this.$refs.deviceManagement;
        let multipleSelection = logInfo.multipleSelection;
        if (multipleSelection.length === 0) {
            this.$message.error(this.$t('notSelectExportHint').toString());
            return;
        }
        let data = {
            end_time: this.endTime,
            keyword: this.keyword,
            start_time: this.startTime,
            type: isLoginLog ? 0 : 1,
        };
        const taskType = isLoginLog ? TASK_TYPE.LOGIN_LOG : TASK_TYPE.OPERATE_LOG;
        let log_ids = [];
        multipleSelection.map((resp) => {
            log_ids.push(resp.id);
        });
        data.log_ids = log_ids;
        const pagination = logInfo.pagination;
        exportLog({ ...data, ...pagination }, taskType).then((resp) => {
            if (resp?.data?.data) {
                window.location.href = resp.data.data;
            }
        });
    }
    handleRefresh() {
        this.handleSearch();
    }
    mounted() { }
};
default_1 = __decorate([
    Component({
        name: 'Log',
        components: {
            operationLog,
            loginLog,
            FullScreen,
            AuthItem,
            deviceManagement,
            SecondaryVerification,
            AuthNewitem,
        },
        i18n: {
            messages: {
                'en-us': {
                    notSelectExportHint: 'Please select the data that you want to export',
                    exportCsv: 'Export Excel',
                    deviceManagement: 'Device Log',
                },
                zh: {
                    notSelectExportHint: '请选择需要导出的数据',
                    exportCsv: '导出Excel',
                    deviceManagement: '设备日志',
                },
            },
        },
    })
], default_1);
export default default_1;
